module.exports = __webpack_public_path__ + "static/media/TrojanHorseman.526add7e.jpg";